module.exports = __webpack_public_path__ + "media/four.e92fd1b5.mp3";